import axiosInstance from '@/app/api/axiosInstance';
import {
  ChequeRecord,
  ChequeRecordCreate,
  ChequeRecordUpdate,
  ChequeRecordFilters,
  PendingChequesParams,
} from '../types/cheque';

// Create a new cheque record
export const createCheque = async (data: ChequeRecordCreate): Promise<ChequeRecord> => {
  const response = await axiosInstance.post<ChequeRecord>('/cheque-records/', data);
  return response.data;
};

// List cheques with filters
export const listCheques = async (filters?: ChequeRecordFilters): Promise<ChequeRecord[]> => {
  const params = new URLSearchParams();

  if (filters) {
    if (filters.party_id !== undefined) params.append('party_id', filters.party_id.toString());
    if (filters.status) params.append('status', filters.status);
    if (filters.clearing_date_from) params.append('clearing_date_from', filters.clearing_date_from);
    if (filters.clearing_date_to) params.append('clearing_date_to', filters.clearing_date_to);
    if (filters.cheque_date_from) params.append('cheque_date_from', filters.cheque_date_from);
    if (filters.cheque_date_to) params.append('cheque_date_to', filters.cheque_date_to);
    if (filters.search) params.append('search', filters.search);
    if (filters.skip !== undefined) params.append('skip', filters.skip.toString());
    if (filters.limit !== undefined) params.append('limit', filters.limit.toString());
  }

  const response = await axiosInstance.get<ChequeRecord[]>('/cheque-records/', { params });
  return response.data;
};

// Get a single cheque by ID
export const getCheque = async (id: number): Promise<ChequeRecord> => {
  const response = await axiosInstance.get<ChequeRecord>(`/cheque-records/${id}`);
  return response.data;
};

// Update cheque (for bounced/cancelled status)
export const updateCheque = async (id: number, data: ChequeRecordUpdate): Promise<ChequeRecord> => {
  const response = await axiosInstance.patch<ChequeRecord>(`/cheque-records/${id}`, data);
  return response.data;
};

// Delete (soft delete) a cheque
export const deleteCheque = async (id: number): Promise<void> => {
  await axiosInstance.delete(`/cheque-records/${id}`);
};

// Get pending cheques that are due for clearing
export const getPendingChequesDue = async (params: PendingChequesParams): Promise<ChequeRecord[]> => {
  const response = await axiosInstance.get<ChequeRecord[]>('/cheque-records/pending/due', { params });
  return response.data;
};